import axios from 'axios'
import Common from '@/components/Common';
import {
	Message,
	MessageBox
} from 'element-ui';
import router from '../router' //引入 vue-router
import store from '../store' //引入 vuex
// 创建一个axios实例
const service = axios.create({
	// 请求超时时间
	timeout: 3000
})

// 添加请求拦截器
service.interceptors.request.use(
	config => {
		// console.log("请求拦截器");
		// console.log(config);
		return config
	},
	err => {
		// console.log(err)
	}
)

//响应拦截
service.interceptors.response.use(
	response => {
		//console.log("响应拦截");
		let res = {}
		res.status = response.status
		res.data = response.data
		// console.log(res);
		return res
	},
	err => console.log(err)
)

//post
const CreateUrls = function(port) {
	let ret = '';
	let that = this;
	ret = sessionStorage.getItem('userData');
	let token = '';
	if (ret != null && ret != '') {
		let UserInfo = JSON.parse(ret)
		token = UserInfo.token;
	}
	console.log("token="+token);
	if (typeof(token) == "undefined") {
		Message.error("登陆失效");
		router.push({
			path: '/'
		});
		store.dispatch('/logout');
		return "";
	} else {
		let url = Common.Url + port + '?token=' + token;
		//console.log(url);
		return url
	}
}
//一般数据发送方法
const urlpost = function(port, posdata, callback) {
	let that = this;
	axios.post(CreateUrls(port), posdata).then(function(res) {
			let reqdata = res.data;
			//console.log(reqdata);
			callback(reqdata);
			if (reqdata.Success == 1) {
				//callback(reqdata);
			} else {
				// Message.error(reqdata.Msg);
				if (reqdata.Msg.indexOf("Token无效") >= 0) {
					router.push({
						path: '/'
					});
					store.dispatch('/logout');
				}else{
					console.log(reqdata);
					Message.error(reqdata.Msg);
				}
			}
		})
		.catch(function(error) {
			Message.error('错误提示: ' + error);
		});

}
// 不穿token
const urlpost1 = function (port, posdata, callback) {
    let that = this;
    axios.post((Common.Url + port), posdata).then(function(res) {
        let reqdata = res.data;
        //console.log(reqdata);
        callback(reqdata);
        if (reqdata.Success == 1) {
            //callback(reqdata);
        } else {
            // Message.error(reqdata.Msg);
        }
    })
        .catch(function(error) {
            Message.error('错误提示: ' + error);
        });
}
const gets = function(port, getdata, callback) {
	//console.log(port);
	axios.post(port, getdata).then(function(res) {
			//console.log(res);
			callback(res);
		})
		.catch(function(error) {
			Message.error('错误提示: ' + error);
		});
}
export default {
	service,
	urlpost,
	urlpost1,
	gets
}
